/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleCreation } from '../../models/role-creation';
import { UserRole } from '../../models/user-role';

export interface TenantsTenantIdRolesPost$Params {
  'Active-Tenant-Identifier': string;

/**
 * tenant identifier
 */
  tenantId: string;
      body: RoleCreation
}

export function tenantsTenantIdRolesPost(http: HttpClient, rootUrl: string, params: TenantsTenantIdRolesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRole>> {
  const rb = new RequestBuilder(rootUrl, tenantsTenantIdRolesPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('tenantId', params.tenantId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserRole>;
    })
  );
}

tenantsTenantIdRolesPost.PATH = '/tenants/{tenantId}/roles';
